import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { observable, action } from 'mobx';
import defer from 'promise-defer';

/**
 * Creates a confirmation request.
 */
var confirmationRequest = function confirmationRequest(opts) {
  return {
    deferred: defer(),
    options: opts || {}
  };
};
var ConfirmDialogState = (_class = /*#__PURE__*/_createClass(function ConfirmDialogState(_opts) {
  var _this = this;
  _classCallCheck(this, ConfirmDialogState);
  _initializerDefineProperty(this, "isOpened", _descriptor, this);
  this.no = function () {
    _this._resolve(false);
  };
  this.yes = function () {
    _this._resolve(true);
  };
  this.hide = action(function () {
    _this._resolve(false);
    _this.isOpened = false;
  });
  this._resolve = action(function (value) {
    if (!_this.confirmationRequest) return;

    // Basically, sometimes we don't want to close the confirmation
    // dialog after getting confirmation.
    // In some cases we reuse the dialog with disabled buttons to
    // show progress updates.
    if (!_this.confirmationRequest.options.manage) {
      _this.isOpened = false;
    }
    _this.confirmationRequest.deferred.resolve(value);
  });
  this.show = action(function (opts) {
    if (_this.confirmationRequest) {
      _this.confirmationRequest.deferred.resolve(false);
    }
    _this.confirmationRequest = confirmationRequest(opts);
    _this.isOpened = true;
    return _this.confirmationRequest.deferred.promise;
  });
  Object.assign(this, _opts);
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpened", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _class);
export default ConfirmDialogState;
//# sourceMappingURL=ConfirmDialogState.js.map
